import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { constants } from "@cinch-nx/data-search";
var defaultFilters = constants.defaultFilters;
var arraysContainsEqualValues = function(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    return a.every(function(item) {
        return b.includes(item);
    }) && b.every(function(item) {
        return a.includes(item);
    });
};
export var getActiveFilters = function(filters) {
    return Object.entries(filters).reduce(function(activeFilters, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var filtersKey = key;
        if (!arraysContainsEqualValues(defaultFilters[filtersKey], value)) {
            activeFilters.push(filtersKey);
        }
        return activeFilters;
    }, []);
};
